import {
  StorageKey,
  storageManager,
} from '@authFlow/utils/SessionStorageManager';

export function setPage(pathName: string): void {
  const urlParams = new URLSearchParams();
  const parametersToSend: Array<StorageKey> = ['src', 'offer', 'custom'];

  parametersToSend.map((param) => {
    const value = storageManager.get(param);
    value && urlParams.set(param, value);
  });

  const redirectTo = storageManager.get('redirectTo');
  redirectTo && urlParams.set('redirect_to', redirectTo);

  const searchString = urlParams.toString() ? `?${urlParams.toString()}` : '';
  const page = pathName + searchString;

  if (window.ga) {
    window.ga('set', 'page', page);
    window.ga('send', 'pageview');
  } else {
    console.warn('window.ga is not defined. SetPage args: ', [page]);
    console.warn('window.ga is not defined. Send pageview');
  }
}
